import { degreesToRadians, DistanceVec2, rayIntersectVertical } from "./util";
export function CalcPlaceFromDiagonal(a, x, shiftFront = 0, shiftBack = 0, pointStart = [0, 0]) {
    const DegA = degreesToRadians(+a);
    const pointBL = pointStart;
    const pointTR = rayIntersectVertical(pointBL, x, DegA);
    const pointBR = [pointBL[0], pointTR[1]];
    const pointTL = [pointTR[0], pointBL[1]];
    const pointShiftLB = rayIntersectVertical(pointBL, -shiftFront, DegA - Math.PI);
    const pointShiftRT = rayIntersectVertical(pointTR, x + shiftBack, DegA);
    const pointShiftLT = [pointShiftLB[0], pointBL[1]];
    const pointShiftRB = [pointShiftRT[0], pointBL[1]];
    const placeFromDiagonal = {
        shift: {
            front: {
                h: DistanceVec2(pointShiftLB, [pointShiftLB[0], pointBL[1]]),
                w: DistanceVec2(pointShiftLB, [pointBL[0], pointShiftLB[1]]),
                l: DistanceVec2(pointShiftLB, pointBL),
                p: {
                    b: pointShiftLB,
                    t: pointShiftLT
                }
            },
            back: {
                h: DistanceVec2(pointShiftRT, [pointShiftRT[0], pointTR[1]]),
                w: DistanceVec2(pointShiftRT, [pointTR[0], pointShiftRT[1]]),
                l: DistanceVec2(pointTR, pointShiftRT),
                p: {
                    b: pointShiftRB,
                    t: pointShiftRT
                }
            }
        },
        p: {
            b: pointBL,
            t: pointTR
        },
        h: DistanceVec2(pointBL, pointBR),
        w: DistanceVec2(pointBR, pointTR),
        l: DistanceVec2(pointBL, pointTR),
    };
    return placeFromDiagonal;
}
